export default __webpack_public_path__ + "static/media/Chatbot-ask-me.cb7bf508.svg";